// The ONE Supabase client for the app (CLAUDE §1). Publishable anon key only; RLS is
// the security boundary. Pinned to the `events` schema so reads target the curated
// public_event_view. No session persistence — the public form is anonymous; the
// dashboard (later) will layer auth on top of this same client.
import { createClient } from "@supabase/supabase-js";
import { env } from "./env.ts";

export const supabase = createClient(env.supabaseUrl, env.supabaseAnonKey, {
  db: { schema: "events" },
  auth: { persistSession: false, autoRefreshToken: false },
  global: { headers: { "x-application-name": "restomag-events-web" } },
});
